// extracted by mini-css-extract-plugin
module.exports = {"backgroundImageContainer":"Background_backgroundImageContainer__2Pmme","backgroundImage":"Background_backgroundImage__1U2Y-","canvasContainer":"Background_canvasContainer__3wyrB"};